function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurpleDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 5.625,
    viewBox: "0 0 10 5.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46907",
    d: "M9.814 64.139a.6.6 0 0 0-.439-.186H.625a.6.6 0 0 0-.44.186.613.613 0 0 0 0 .879l4.375 4.374a.613.613 0 0 0 .879 0l4.375-4.375a.613.613 0 0 0 0-.879z",
    transform: "translate(0 -63.953)",
    style: {
      fill: "#3c51be"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleDownIcon);
export default __webpack_public_path__ + "static/media/purpleDownIcon.7cf180e50477dee9daa62e8f08470c5b.svg";
export { ForwardRef as ReactComponent };